<template>
  <div>
    <v-dialog v-model="dialog.image"
      @keydown.esc="dialog.image = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-title 
          class="d-flex align-center pa-4 text-right popup-header">
          <div
            class="title font-weight-bold">
            Ubah Gambar Tanda Tangan
          </div>

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon> -->

          <v-icon 
            @click="dialog.image = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="py-0 my-4">
          <uploadfolder
            v-model="upload.image" 
            style="height: 250px; width: 250px">
            <div 
              slot="activator"
              class="cursor-pointer">
              <v-card 
                flat
                height="250"
                class="d-flex align-center justify-center"
                style="border-radius: 15px;
                      border: 2px solid #eaeaea; 
                      border-style: dashed;">
                <div v-if="img_ttd.length < 1">
                  <v-icon v-if="!process.image"
                    size="60" 
                    color="#718EBF">
                    mdi-cloud-upload-outline
                  </v-icon>

                  <v-progress-circular v-else
                    indeterminate
                    :color="set_color">
                  </v-progress-circular>
                </div>

                <v-img v-else
                  contain
                  height="250"
                  :src="img_ttd" 
                  :alt="img_ttd"
                  class="text-center d-flex align-center">
                  <div 
                    class="d-flex aling-center justify-center" 
                    style="width: 100%; height: auto;">
                    <v-icon v-if="!process.image"
                      size="60" 
                      color="white">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>
                </v-img>
              </v-card>
            </div>
          </uploadfolder>

          <div v-if="message.error.length > 0"
            class="text-center mt-6">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <v-btn
            @click="saveImgtdd()"
            :loading="process.form"
            :disabled="process.form || img_ttd.length < 1"
            width="120"
            elevation="0"
            color="green"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Simpan
          </v-btn>

          <v-btn
            @click="dialog.image = false;"
            :disabled="process.form"
            width="120"
            outlined
            elevation="0"
            color="red"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row
      class="pa-4">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat
          min-height="calc(100vh - 245px)">

          <v-card-text
            v-if="Object.keys(detail).length < 1" 
            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-2 title">
                Mohon Tunggu...
              </div>
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="Object.keys(detail).length > 0">
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <table>
                  <tr>
                    <td>
                      Nama
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Kode Customer
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      :
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.activation_code }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Nama Alias
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.name_alias }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      NIK
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.nik }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Email
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.email === '' ? '-' : detail.email }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Tempat, tanggal lahir
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      <span v-if="detail.birthplace === '' && detail.birthdate === ''">
                      -
                    </span>
                    <span v-else>
                      {{ detail.birthplace }}, {{ detail.birthdate | date }}
                    </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      NPWP
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.npwp === '' ? '-' : detail.npwp }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Agama
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      : 
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.religion !== '' ? detail.religion : '-'}}
                    </td>
                  </tr>

                </table>
                <!-- <div>
                  <div 
                    class="fs-14">
                    Nama
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.name }}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    Nama Alias
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.name_alias }}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    NIK
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.nik }}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    Email
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.email }}
                  </div>
                </div>


                <div>
                  <div 
                    class="fs-14">
                    Tempat, tanggal lahir
                  </div>
                  <div class="fs-16 label-input">
                    <span v-if="detail.birthplace === '' && detail.birthdate === ''">
                      -
                    </span>
                    <span v-else>
                      {{ detail.birthplace }}, {{ detail.birthdate | date }}
                    </span>
                  </div>
                </div> -->

                <!-- <div>
                  <div 
                    class="fs-14">
                    NPWP
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.npwp }}
                  </div>
                </div> -->
  
                <!-- <div>
                  <div 
                    class="fs-14">
                    Agama
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.religion !== '' ? detail.religion : '-'}}
                  </div>
                </div> -->


                <div>
                  <div 
                    class="fs-14">
                    <!-- <span class="red--text">*</span> -->
                    Mobilephone
                  </div>
                  <div class="fs-16 label-input">
                    <span v-if="detail.mobilephone_arr.length > 0">
                      <div >
                        <table>
                          <tr v-for="(item, i) in detail.mobilephone_arr" :key="i">
                            <td>
                              <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                            </td>
                            <td class="text-left py-1 pr-1 pl-5">
                              : {{ item }}
                            </td>
                          </tr>
                        </table>
                        <!-- <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>: {{ item }}  -->
                      </div>
                    </span>
                    <span v-else>
                      -
                    </span>
                  </div>
                </div>
  
                <div>
                  <div 
                    class="fs-14">
                    <!-- <span class="red--text">*</span> -->
                    Alamat
                  </div>
                  <div class="fs-16 label-input text-lowercase">
                    {{ detail.address }}, {{ detail.village_name !== '' ? detail.village_name : '-'}}, {{ detail.subdistrict_name !== '' ? detail.subdistrict_name : '-'}}, {{ detail.city_name !== '' ? detail.city_name : '-'}} - {{ detail.province_name !== '' ? detail.province_name : '-'}}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    <!-- <span class="red--text">*</span> -->
                    Tanda Tangan
                  </div>
                  <div>
                    <v-btn
                      elevation="0"
                      :color="`orange`"
                      class="body-2 font-weight-bold text-capitalize white--text mt-2 mb-1"
                      style="border-radius: 10px;"
                      @click="img_ttd = ''; dialog.image = true; message.error = '';">
                      Ubah Tanda Tangan
                    </v-btn>
                  </div>
                  <div class="fs-16 label-input">
                    <div style="border: 1px solid #DFEAF2; border-radius: 15px; width: 250px;" class="mt-2">
                      <!-- <div class="mb-3 fs-14">
                        Perbesar Gambar:
                        <v-btn @click="$refs.zoomerttd.zoomIn()" small color="blue" class="body-2 white--text text-capitalize ml-2" style="border-radius: 10px;">
                          <v-icon 
                            size="20">
                            mdi-plus
                          </v-icon>
                        </v-btn>
                        <v-btn @click="$refs.zoomerttd.zoomOut()" :disabled="!zoomedTtd" small color="warning" class="body-2 white--text text-capitalize ml-4" style="border-radius: 10px;">
                          <v-icon 
                            size="20">
                            mdi-minus
                          </v-icon>
                        </v-btn>
                      </div> -->
                      <v-img
                        :src="detail.ttd"
                        contain
                        width="250"
                        height="150"
                        >
                      </v-img>
                      <!-- <v-zoomer
                        ref="zoomerttd"
                        style="width: 100%; height: 250px; border: solid 1px silver;"
                        :aspect-ratio="imageAspectRatioTtd"
                        :max-scale="10"
                        :zooming-elastic="false"
                        :zoomed.sync="zoomedTtd"
                      >
                        <img :src="detail.ttd" style="object-fit: contain; width: 100%; height: 100%;" @load="onImageLoadAkta">
                      </v-zoomer> -->
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="py-0" style="border-left: 1px solid #eee;">
                <table>
                  <tr>
                    <td>
                      Plafon
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      :
                    </td>
                    <td class="fs-16 label-input">
                      Rp. {{ detail.plafon | pricing }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Faktur
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      :
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.faktur }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      TOP
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      :
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.term }} Hari
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Sales Register
                    </td>
                    <td style="width: 60px" class="text-right py-1 pr-1">
                      :
                    </td>
                    <td class="fs-16 label-input">
                      {{ detail.reg_by }}
                    </td>
                  </tr>
                </table>

                <!-- <div>
                  <div 
                    class="fs-14">
                    Plafon
                  </div>
                  <div class="fs-16 label-input">
                    Rp. {{ detail.plafon | pricing }}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    Faktur
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.faktur }}
                  </div>
                </div>

                <div>
                  <div 
                    class="fs-14">
                    TOP
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.term }} Hari
                  </div>
                </div>
                <div>
                  <div 
                    class="fs-14">
                    Sales Register
                  </div>
                  <div class="fs-16 label-input">
                    {{ detail.reg_by }}
                  </div>
                </div> -->
                <div>
                  <div 
                    class="fs-14 mt-1">
                    <!-- <span class="red--text">*</span> -->
                    Peta Lokasi
                  </div>
                  <div class="fs-16 label-input">
                    <div v-if="detail.latitude === ''">
                      -
                    </div>
                    <div class="mt-2" v-if="detail.latitude !== ''">
                      <!-- <a 
                      :href="`https://www.google.com/maps/search/?api=1&query=${detail.latitude},${detail.longitude}`"
                      style="color:#0000FF;text-align:left" 
                        target="_blank"> -->
                          <!-- <iframe 
                            width="100%" 
                            height="250" 
                            frameborder="0" 
                            scrolling="no" 
                            marginheight="0" 
                            marginwidth="0" 
                            :src="`https://maps.google.com/maps?q=${detail.latitude},${detail.longitude}&hl=es&z=14&amp;output=embed`"
                            >
                          </iframe> -->

                          <gmap-map
                            :center="center"
                            :zoom="18"
                            :options="{
                              zoomControl: true,
                              mapTypeControl: false,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: true,
                              disableDefaultUi: false
                            }"
                            style="width: 100%; height: 250px;">

                            <gmap-marker
                              :position="center">
                            </gmap-marker>
                          </gmap-map>
                        <!-- </a> -->
                      </div>
                  </div>
                </div>
  
                <div v-if="Object.keys(visit).length > 0">
                  <div 
                    class="fs-14" mt-2>
                    <!-- <span class="red--text">*</span> -->
                    Peta Lokasi Registrasi
                  </div>
                  <div class="fs-16 label-input">
                    <div v-if="visit.latitude === ''">
                      -
                    </div>
                    <div class="mt-2" v-if="visit.latitude !== ''">
                      <!-- <a 
                      :href="`https://www.google.com/maps/search/?api=1&query=${visit.latitude},${visit.longitude}`"
                      style="color:#0000FF;text-align:left" 
                        target="_blank"> -->
                          <!-- <iframe 
                            width="100%" 
                            height="250" 
                            frameborder="0" 
                            scrolling="no" 
                            marginheight="0" 
                            marginwidth="0" 
                            :src="`https://maps.google.com/maps?q=${visit.latitude},${visit.longitude}&hl=es&z=14&amp;output=embed`"
                            >
                          </iframe> -->
                          <gmap-map
                            :center="center_visit"
                            :zoom="18"
                            :options="{
                              zoomControl: true,
                              mapTypeControl: false,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: true,
                              disableDefaultUi: false
                            }"
                            style="width: 100%; height: 250px;">

                            <gmap-marker
                              :position="center_visit">
                            </gmap-marker>
                          </gmap-map>
                        <!-- </a> -->
                      </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="py-0">

                
              </v-col>
            </v-row>

            <div v-if="message.error.length > 0"
              class="text-center my-4 d-flex align-center">
              <div
                class="error--text">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          dialog: {
            image: false,
            fullscreen: false
          },
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          img_ttd: '',
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,
          sales: {},
          visit: {},
          center: {
            lat: 0,
            lng: 0
          },
          center_visit: {
            lat: 0,
            lng: 0
          },
          upload: {
            image: null
          },
  
          process: {
            form: false,
            image: false,
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import('@/components/upload/folder.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process

              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.img_ttd = this.upload.image.fileuri

                // this.save_image()
              }
            }
          },
          deep: true
        },
        'detail': {
          handler: function (val) {
            // if (Object.keys(val).length > 0) {
              this.fetchSales()
            // }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        // if (Object.keys(this.detail).length > 0) {
        //   this.fetchSales()
        // }
      },
      methods: {
        async fetchSales () {
          this.process.load = true

          let params = {
          limit: 10000000000000,

          'category_user_id[eq]': '8',
          name: this.detail.reg_by
        }

        await get(`admin/user/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.sales = res.results.data[0]

              this.center = {
                lat: (this.detail.latitude)*1,
                lng: (this.detail.longitude)*1
              }
              
            }
            this.fetchVisit(this.sales.id)
            this.process.load = false
          })
        },
        async fetchVisit (id) {
          this.process.load = true

          let params = {
          limit: 10000000000000,
          sales_id: id,
          customer_id: this.$route.params.id,
          type: 'NOO'
        }

        await get(`admin/visit/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.visit = res.results.data[0]
              this.center_visit = {
                lat: (this.visit.latitude)*1,
                lng: (this.visit.longitude)*1
              }
              
            }
            this.process.load = false
          })
        },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -2.9198476, 
              lng: 104.645729
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },
      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
          this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
        async saveImgtdd () {
          this.message.error = ''

          this.process.form = true

          await post(`admin/customer/update`, { data: 
            {
              id: this.detail.id,
              ttd: this.img_ttd
            }
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.$emit('update')
              this.upload.image = null

              this.dialog.image = false
              this.dialog.snackbar = true
              this.message.success = res.message
              this.message.error = ''
            } else {
              this.message.error = res.message
            }
          })
        },
      }
    }
  </script>